import { isMockMode } from "./client";
import mediaFixture from "./mock/fixtures/amazon-media.ok.json";
import { AMZ_MEDIA_BASE } from "../types/amazonMedia";
import type { AmzMediaItem, AmzMediaManifest } from "../types/amazonMedia";

/** 画像ライブラリ（stoq-amazon-media の manifest.json）を読む。BFF を通さない公開ファイルなので認証は不要。 */
export async function fetchAmazonMedia(): Promise<AmzMediaManifest> {
  if (isMockMode()) return mediaFixture as AmzMediaManifest;
  const res = await fetch(`${AMZ_MEDIA_BASE}manifest.json`, { cache: "no-cache" });
  if (!res.ok) throw new Error(`画像ライブラリを読み込めませんでした（HTTP ${res.status}）`);
  const body = (await res.json()) as AmzMediaManifest;
  if (!body || !Array.isArray(body.items)) throw new Error("画像ライブラリの形式が正しくありません");
  return body;
}

/** "1枚目 MAIN" / "2枚目" … */
export function mediaSlotLabel(it: AmzMediaItem): string {
  if (it.slot === "main") return "1枚目 MAIN";
  if (/^\d{2}$/.test(it.slot)) return `${Number(it.slot)}枚目`;
  return "—";
}

/** SKU の最新版を Amazon の並び順（メイン→2枚目→…）で返す */
export function latestSetForSku(items: AmzMediaItem[], sku: string): AmzMediaItem[] {
  return items.filter((i) => i.sku === sku && i.latest).sort((a, b) => a.order - b.order);
}

export function formatBytes(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}MB`;
  return `${Math.round(n / 1000)}KB`;
}
